window.chartPlanungssimulation = {
	data: {
		simulationsbreite: [],
		best_case: [],
		mittlere_entwicklung: [],
		worst_case: [],
		planungsziel: [],
		simulationsbreite_real: [],
		best_case_real: [],
		mittlere_entwicklung_real: [],
		worst_case_real: [],
		planungsziel_real: [],
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_planungssimulation", {
			chart: {
				marginTop: 20,
				zooming: {
					type: "undefined",
				},
				werteDarstellung: "nominal", // ["nominal", "real"]
			},

			subtitle: {
				useHTML: true,
				align: "left",
				text: "Liquidität",
				x: 140,
				y: 90,
				style: {
					//fontSize: '14px',
					fontWeight: "bold",
				},
			},

			legend: {
				enabled: true,
				alignColumns: false,
				itemDistance: 28,
			},

			xAxis: {
				anzeigeFormat: "monat",
			},

			tooltip: {
				enabled: true,
				animation: false,
				pointFormatter: function () {
					if (this.y != 0) {
						return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 0)}&nbsp;€</span>`
					} else return false
				},
			},

			plotOptions: {
				series: {
					dataGrouping: {
						units: [
							["month", [1]], // ['month', [1]],
						],
					},
				},
				arearange: {
					enableMouseTracking: false,
					states: {
						inactive: {
							opacity: 1,
						},
					},
				},
				line: {
					lineWidth: 4,
				},
			},

			series: this.series(),
		})
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.series()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) {
				if (this.chart.options.chart.werteDarstellung === "real") {
					s.setData(serie.dataReal, false)
				} else {
					s.setData(serie.dataNominal, false)
				}
				s.options.dataNominal = serie.dataNominal
				s.options.dataReal = serie.dataReal
			}
		})

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	series() {
		return [
			{
				name: "simulationsbreite",
				id: "simulationsbreite",
				legendName: "Simulationsbreite",
				type: "arearange",
				color: {
					linearGradient: {
						x1: 0,
						x2: 0,
						y1: 0,
						y2: 1,
					},
					stops: [
						[0, "#CCE3DE"],
						[1, "#96C5BB"],
					],
				},
				zIndex: 0,
				data: this.data.simulationsbreite,
				dataNominal: this.data.simulationsbreite,
				dataReal: this.data.simulationsbreite_real,
			},
			{
				name: "Best-Case",
				id: "best",
				legendName: "Best-Case",
				color: "#F5B700",
				zIndex: 1,
				data: this.data.best_case,
				dataNominal: this.data.best_case,
				dataReal: this.data.best_case_real,
			},
			{
				name: "Mittlere Entwicklung",
				id: "mittel",
				legendName: "Mittlere Entwicklung",
				color: farbeLiquidierung,
				zIndex: 1,
				data: this.data.mittlere_entwicklung,
				dataNominal: this.data.mittlere_entwicklung,
				dataReal: this.data.mittlere_entwicklung_real,
			},
			{
				name: "Worst-Case",
				id: "worst",
				legendName: "Worst-Case",
				color: "#FF7F11", //#d5a021', //#ecc30b',
				zIndex: 1,
				data: this.data.worst_case,
				dataNominal: this.data.worst_case,
				dataReal: this.data.worst_case_real,
			},
			{
				name: "Planungsziel",
				id: "planungsziel",
				legendName: "Planungsziel",
				color: chartFontColorGrau,
				dashStyle: "longdash",
				lineWidth: 2,
				zIndex: 2,
				enableMouseTracking: false,
				states: { inactive: { opacity: 1 }, hover: { enabled: false } },
				data: this.data.planungsziel,
				dataNominal: this.data.planungsziel,
				dataReal: this.data.planungsziel_real,
			},
		]
	},
}
